import React, {
    Component
} from 'react';

import {
    connect
} from 'react-redux'
import {
    map,
    includes
} from 'lodash-es'
import {
    selectCheckbox
} from '../actions/select'

import {
    propertyClassName,
    getPropertyState
} from '../utils/parsers'

import classNames from 'classnames';

class SelectCheckbox extends Component {
    renderItem = (item, i) => {
        const {selections, onSelect, itemClass, property, currency = '€'} = this.props;
        const {id, description, longDescription, price, info} = item;
        const classes = classNames(itemClass);
        const isSelected = includes(selections, id);
        const checkClasses = classNames({
            "item-label custom-checkbox": true,
            "active": isSelected
        });
        return (
            <div className={classes} key={i}>
                <label className={checkClasses}>
                    <input type="checkbox"
                           className="custom-input"
                           name={property + "Options"}
                           id={property + "Option" + i}
                           value={"option" + i}
                           checked={isSelected}
                           onChange={_ => onSelect(id, property)}
                    />
                    {property !== 'accentPanel' || <span className={classNames("accent-panel-color", propertyClassName(description))}/>}
                    <span className="item-details">
                        <span className="description">{description}</span>
                        {!price || <span className="price">{price}{currency}</span>}
                        {!info || <span className="more-info">{info}</span>}
                    </span>
                    <span className="indicator icon-yc-checkmark"/>
                    {!longDescription ||
                    <a href="#accessoryInfoModal" className="btn-accessory-info" data-bs-toggle="modal" data-bs-target="#accessoryInfoModal">
                        <span className="icon-yc-info-circled"><span className="sr-only">Info</span></span>
                    </a>
                    }
                    {!longDescription || <div className="accessory-info-content" dangerouslySetInnerHTML={{__html: longDescription}} />}
                </label>
            </div>
        )
    };

    render() {
        const {items, itemsClass, id} = this.props;
        return (
            <fieldset id={id}>
                <div className={itemsClass}>
                    {map(items, this.renderItem)}
                </div>
            </fieldset>
        );
    }
}

const mapStateToProps = (state, props) => {
    return getPropertyState(state, props);
};

const mapDispatchToProps = (dispatch) => ({
    onSelect: (id, property) => dispatch(selectCheckbox(id, property))
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectCheckbox);



// WEBPACK FOOTER //
// ./src/components/SelectCheckbox.js